export default __webpack_public_path__ + "static/media/addNote.549f28a5.svg";